import { useMemo } from 'react'

export const useBulkValues = (depots: uui.domain.client.rm.Depot[]) => {
  return useMemo(() => {
    let address = ''
    let setupCost = NaN
    let setupTimeSec = NaN
    let addressMultipleValues = false
    let setupCostMultipleValues = false
    let setupTimeSecMultipleValues = false

    for (const depot of depots) {
      const {
        setupCost: cost,
        setupTimeSec: time,
        location: { address: depotAddress },
      } = depot

      if (Number.isNaN(setupCost)) {
        setupCost = cost
      } else if (!setupCostMultipleValues && setupCost !== cost) {
        setupCostMultipleValues = true
      }

      if (Number.isNaN(setupTimeSec)) {
        setupTimeSec = time
      } else if (!setupTimeSecMultipleValues && setupTimeSec !== time) {
        setupTimeSecMultipleValues = true
      }

      if (!address) {
        address = depotAddress
      } else if (!addressMultipleValues && address !== depotAddress) {
        addressMultipleValues = true
      }
    }

    return {
      address,
      setupCost,
      setupTimeSec,
      addressMultipleValues,
      setupCostMultipleValues,
      setupTimeSecMultipleValues,
    }
  }, [depots])
}
